import React, { Component } from 'react'
import { connect } from 'react-redux'
import { googleLoginRequest } from '../../../../action/auth-actions'
import superagent from 'superagent'

class LoginWithGoogle extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.setGoogleSignUp()
  }

  setGoogleSignUp() {
    const scriptGoogleTagId = 'sign-up-with-google-script-tag'
    let scriptGoogleTag = document.getElementById(scriptGoogleTagId)
    if (scriptGoogleTag) {
      scriptGoogleTag.parentNode.removeChild(scriptGoogleTag)
    }
    const script = document.createElement('script')
    script.id = scriptGoogleTagId
    script.src = 'https://apis.google.com/js/platform.js?onload=init'
    script.async = true
    script.defer = true
    document.getElementsByTagName('body')[0].appendChild(script)
    scriptGoogleTag = document.getElementById(scriptGoogleTagId)

    scriptGoogleTag.onload = () => {
      this.googleInit()
    }
  }

  googleInit() {
    window.gapi.load('auth2', () => {
      // Retrieve the singleton for the GoogleAuth library and set up the client.
      this.attachSignUp(this.retrienAuth2())
    })
  }

  retrienAuth2() {
    const CLIENT_ID = '346918811661-4g8tav9je5earr4ca5f37naisgi8drgm.apps.googleusercontent.com'
    return window.gapi.auth2.init({
      client_id: CLIENT_ID,
      cookiepolicy: 'single_host_origin'
    })
  }

  attachSignUp(auth2) {
    let element = document.getElementById('id-sign-up-with-google')
    auth2.attachClickHandler(
      element,
      {},
      googleUser => {
        const googleUserProfile = googleUser.getBasicProfile()
        const id_token = googleUser.getAuthResponse().id_token
        const authObject = {
          token: id_token,
          stateName: '',
          photoUrl: googleUserProfile.getImageUrl(),
          loginProviderId: 1,
          externalLoginId: '',
          email: googleUserProfile.getEmail(),
          password: '',
          deviceId: '',
          firstName: googleUserProfile.getName(),
          lastName: googleUserProfile.getFamilyName()
        }
        console.log('Sign Up as: ' + googleUser.getBasicProfile())
        superagent
          .post(`${__API_URI__}/Auth/GoogleAuth`)
          .set('Content-Type', 'application/json')
          .set('Platform', 'Web')
          .set('Version', `${__version__}`)
          .send(JSON.stringify(authObject))
          .end((err, res) => {
            if (res) {
              this.props.googleLogin(authObject).then((err, res) => {
                let timeout
                if (res) timeout = res.accessToken.expiresSeconds
                if (err) return console.log(err.text)
              })
            }
          })
      },
      error => {
        console.log(JSON.stringify(error, undefined, 2))
      }
    )
  }

  signOut() {
    let auth2 = window.gapi.auth2.getAuthInstance()
    auth2.signOut().then(function () {
      console.log('Google User signed out.')
    })
  }

  render() {
    return (
      <div className="button-facebook">
        <button
          style={{ backgroundColor: 'white', margin: '1em 0' }}
          id="id-sign-up-with-google"
          label="Login with Facebook"
          onClick={() => this.setGoogleSignUp()}
        >
          <div style={{ display: 'flex', width: '100%' }}>
            <img src="../../../asset/Logo_Google-G_Multi-Colorhdpi.png" />
            <span className="buttonText" style={{ color: '#1D1D1D' }}>Google</span>
          </div>
        </button>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  googleLogin: googleAuthObj => dispatch(googleLoginRequest(googleAuthObj))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginWithGoogle)
